export var ApiUrls = {
  HMCandidate: {
    AssigToJob: {
      GetJobs: "HMCandidate/GetLookUpData",
      AssignToJob: "Search/AssignToJob",
    },
    GetCandidateNameById: "HMCandidate/GetCandidateNameById?id=",
    StartTimedForm: "Candidate/StartTimedForm",
    UpdateApplicationTimedCandidateFromGroupTime: "Candidate/UpdateApplicationTimedCandidateFromGroupTime",
    UpdateApplicationTimedCandidateFromGroup: "Candidate/UpdateApplicationTimedCandidateFromGroup",
    GetSpecialAdjustmentDetails: "Candidate/GetSpecialAdjustmentDetails",
    SaveSpecialAdjustmentDetails: "Candidate/SaveSpecialAdjustmentDetails",
    SaveAssessmentFormAnswers: "Candidate/SaveAssessmentFormAnswers",
    GetAssessmentDetails: "Candidate/GetAssessmentDetails"

  },
  Login: {
    Login: "Login/Login",
    RefreshToken: "Login/RefreshToken",
    AnonymousToken: "Login/AnonymousToken",
    GetOwnSecurityRoleDetail: "SecurityRoles/GetOwnSecurityRoleDetail",
    SSOToken: "Login/SSOToken",//"http://localhost:43344/api/Login/SSOToken",
    SSOLogin: "Login/SSOLogin",
    CASLogin: "api/Login/CASLogin?ngsw-bypass=true",
    SSO: "SSOLogin",
    ApiSSOLogin: "api/Login/SSOLogin?ngsw-bypass=true",
  },

  ForgotPassword: {
    ForgotPassword: "SystemSettings/ForgotPassword?userName=",
    SendPasswordRemainder: "SystemSettings/SendPasswordRemainder?userName=",
    ForgotPasswordURl: "ForgotPassword",

    UpdatePassword: "updateUserPassword",


  },
  TwoFactorAuthentificatoin: {
    VerifyEmailCode: "Login/VerifyEmailCode",
    GetQrCode: "Login/GetQrCode",
    VerifyCode: "Login/VerifyAccessCode",
    Enable2FAForUser: "UserManagement/Enable2FAForUser?UserId="
  },
  SystemCustomization: {
    Get: "SystemSettings/GetSystemCustomizations",
    Save: "SystemSettings/SaveSystemCustomizations"
  },
  SecurityRoles: {
    Save: "SecurityRoles/SaveSecurityRole",
    CreateGet: "SecurityRoles/GetSecurityRoleViewModel/",
    GetDetails: "SecurityRoles/GetSecurityRoleDetails",
    GetDetailsList: "SecurityRoles/GetSecurityRoleDetailsList"
  },
  CustomFields: {
    Save: "CustomFields/SaveCustomField",
    CreateGet: "CustomFields/GetCustomFieldsViewModel/"
  },
  ApplicationTemplates: {
    Get: "ApplicationTemplate/GetApplicationTemplateVM/",
    UpdateSave: "ApplicationTemplate/SaveApplicationTemplateVM",
    CreateSave: "ApplicationTemplate/SaveApplicationTemplate",
    UpdateSactionSave: "ApplicationTemplate/SaveApplicationTemplateSection",
    CustomFieldSave: "ApplicationTemplate/SaveTemplateCustomField",
    UpdateSactionDelete: "ApplicationTemplate/DeleteApplicationTemplateSection/",
    UpdateSactionGet: "ApplicationTemplate/ApplicationTemplateSectionSetting",
    UpdateSactionGetAll: "ApplicationTemplate/ApplicationTemplateSectionSettingAll",
    DeleteApplicationTemplate: "ApplicationTemplate/DeleteApplicationTemplate/"
  },
  //Lookup: {
  //  GetCustomFields: "LookUp/GetCustomFields",
  //  GetLocations: "LookUp/GetSystemLocations",
  //  GetAgencies: "LookUp/GetAgencies",
  //  GetAdverts: "LookUp/GetAdvertCategories?pram=",
  //  GetEmails: "LookUp/GetStandarEmails",
  //  GetAutoStatus: "LookUp/getAutoStatus",
  //  GetApplicationStatusLookUp: "GeneralSetup/GetApplicationStatusLookUp",
  //  GetInitialTest: "LookUp/getInitialTest",
  //  GetDepartments: "LookUp/GetDepartments",
  //  getEthicOrgin: "LookUp/getEthicOrgin",
  //  GetDataFields: "LookUp/GetDataFields",
  //  GetDivisions: "LookUp/GetDivisions",
  //  GetCampaigns: "LookUp/GetCampaigns?id=",
  //  GetLibraryType: "LookUp/GetLibraryTypes",
  //  GetRegion: "LookUp/GetRegions",
  //  GetCountry: "LookUp/GetCountry",
  //  GetRegionalManager: "LookUp/GetRegionalManager",
  //  GetApplicationTemplates: "LookUp/GetApplicationTemplates",
  //  GetApplicationStatuses: "LookUp/GetApplicationStatuses",
  //  GetApplicationStatuses_Server: "LookUp/GetApplicationStatuses_Server",
  //  GetApplicationStatusesForAgencies: "LookUp/GetApplicationStatusesForAgencies",
  //  GetJobs: "LookUp/GetJobs",
  //  GetTeamManager: "LookUp/GetTeamManagers",
  //  GetrequisitionUser: "LookUp/GetrequisitionUser",
  //  GetSystemUser: "Talent/GetSystemUser",
  //  GetTalentPoolAllLookUp: "Talent/GetTalentPoolAllLookUp",
  //  GetCategories: "LookUp/GetCategories",
  //  GetSystemEmployment: "LookUp/GetSystemEmployment",
  //  GetSalaryBands: "LookUp/GetSalaryBands",
  //  GetSkillsCategory: "LookUp/GetSkillsCategory",
  //  GetSkills: "LookUp/GetSkills",
  //  GetSystemJobStatuses: "LookUp/GetSystemJobStatuses",
  //  GetSystemUser_Lookup: "LookUp/GetSystemUser_Lookup",
  //  GetSystemUser_Lookup_Server: "LookUp/GetSystemUser_Lookup_Server",

  //  GetAssessment_Lookup: "LookUp/GetAssessment_Lookup",
  //  GetDocument_Lookup: "LookUp/GetDocument_Lookup",
  //  GetContract_Lookup: "LookUp/GetContract_Lookup",
  //  GetGreenRoomTemplates: "LookUp/GetGreenRoomTemplates",
  //  GetSecurityRoles: "LookUp/GetSecurityRoles",
  //  GetSecurityRolesLookupServer: "LookUp/GetSecurityRoles_Lookup_Server",
  //  GetSystemTeams: "LookUp/GetSystemTeams",
  //  GetSystemLocationsByRegion: "LookUp/GetSystemLocationsByRegion?RegionId=",
  //  GetAppointmentType_Lookup: "LookUp/GetAppointmentType_Lookup",
  //  GetAddressBook: "LookUp/GetAddressBook_Lookup",
  //  GetAllSystemUser: "LookUp/GetAllSystemUser_Lookup",
  //  GetDocumentLibrary: "LookUp/GetDocumentLibrary_Lookup",
  //  CalendarDetailsLookUp: "Calendar/CalendarDetailsLookUp",
  //  GetJobTitles: "LookUp/GetJobTitles",
  //  GetSchoolLocations: "LookUp/GetSchoolLocations",
  //  GetBookedStatus: "Calendar/GetBookedStatus",
  //  GetStatusChangeReasons: "LookUp/GetStatusChangeReasons",
  //  GetJobAndTemplate: "LookUp/GetJobLockups?pram=",
  //  GetGBGroupPins: "LookUp/GetGBGroupPins",
  //  GetSchoolSubject: "LookUp/GetSchoolSubject",
  //},
  GeneralSettings: {
    Tiles: "Settings/GeneralSettings",
    GetListing: "GeneralSetup/GetListing",
    Save: "GeneralSetup/Save",
    SaveTranslation: "GeneralSetup/SaveTranslation?controllerName=",
    GetById: "GeneralSetup/GetById?id=",
    GetApplicationsStatusById: "GeneralSetup/GetApplicationsStatusById?id=",
    Archived: "GeneralSetup/Archived",
    NameParams: "&controllerName=",
    GetForTranslation: "GeneralSetup/GetForTranslation?id=",
    GetTranlationCount: "GeneralSetup/GetTranlationCount?controllerName=",
    ShowAgency: "GeneralSetup/ShowAgency?id=",

    GetJobRegionListing: "GeneralSetup/GetJobRegionListing",
    JobRegionSave: "GeneralSetup/JobRegionSave",
    GetJobRegionById: "GeneralSetup/GetJobRegionById?id=",
    JobRegionArchived: "GeneralSetup/JobRegionArchived",
    GetJobTitlesListing: "GeneralSetup/GetJobTitlesListing",
    JobTitlesSave: "GeneralSetup/JobTitlesSave",
    GetJobTitlesById: "GeneralSetup/GetJobTitlesById?id=",
    JobTitlesArchived: "GeneralSetup/JobTitlesArchived",
    GetLocationListing: "GeneralSetup/GetLocationListing",
    LocationSave: "GeneralSetup/LocationSave",
    GetLocationById: "GeneralSetup/GetLocationById?id=",
    LocationArchived: "GeneralSetup/LocationArchived",
    GetLatitudeLongLongitude: "GeneralSetup/GetLatitudeLongLongitude?postCode=",

    GetPackageListing: "GeneralSetup/GetPackageListing",
    PackageSave: "GeneralSetup/PackageSave",
    GetPackageById: "GeneralSetup/GetPackageById?id=",
    PackageArchived: "GeneralSetup/PackageArchived",
    GetSalaryBandListing: "GeneralSetup/GetSalaryBandListing",
    SalaryBandSave: "GeneralSetup/SalaryBandSave",
    GetSalaryBandById: "GeneralSetup/GetSalaryBandById?id=",
    SalaryBandArchived: "GeneralSetup/SalaryBandArchived",
    GetSchoolLocationListing: "GeneralSetup/GetSchoolLocationListing",
    SchoolLocationSave: "GeneralSetup/SchoolLocationSave",
    GetSchoolLocationById: "GeneralSetup/GetSchoolLocationById?id=",
    SchoolLocationArchived: "GeneralSetup/SchoolLocationArchived",
    GetSchoolSubjectListing: "GeneralSetup/GetSchoolSubjectListing",
    SchoolSubjectSave: "GeneralSetup/SchoolSubjectSave",

    GetSchoolSubjectById: "GeneralSetup/GetSchoolSubjectById?id=",
    SchoolSubjectArchived: "GeneralSetup/SchoolSubjectArchived",
    GetStatusChangeReasonListing: "GeneralSetup/GetStatusChangeReasonListing",
    StatusChangeReasonSave: "GeneralSetup/StatusChangeReasonSave",
    GetStatusChangeReasonById: "GeneralSetup/GetStatusChangeReasonById?id=",
    StatusChangeReasonArchived: "GeneralSetup/StatusChangeReasonArchived",
    GetWorkLevelListing: "GeneralSetup/GetWorkLevelListing",
    WorkLevelSave: "GeneralSetup/WorkLevelSave",
    GetWorkLevelById: "GeneralSetup/GetWorkLevelById?id=",
    WorkLevelArchived: "GeneralSetup/WorkLevelArchived",
    GetJobLevelListing: "GeneralSetup/GetJobLevelListing",
    JobLevelSave: "GeneralSetup/JobLevelSave",
    GetJobLevelById: "GeneralSetup/GetJobLevelById?id=",
    JobLevelArchived: "GeneralSetup/JobLevelArchived",
    GetJobCodeListing: "GeneralSetup/GetJobCodeListing",
    JobCodeSave: "GeneralSetup/JobCodeSave",
    GetJobCodeById: "GeneralSetup/GetJobCodeById?id=",
    JobCodeArchived: "GeneralSetup/JobCodeArchived",
    GetJobCategoryListing: "GeneralSetup/GetJobCategoryListing",
    JobCategorySave: "GeneralSetup/JobCategorySave",
    GetJobCategoryById: "GeneralSetup/GetJobCategoryById?id=",
    JobCategoryArchived: "GeneralSetup/JobCategoryArchived",
    GetGBGroupPinListing: "GeneralSetup/GetGBGroupPinListing",
    GBGroupPinSave: "GeneralSetup/GBGroupPinSave",
    GetGBGroupPinById: "GeneralSetup/GetGBGroupPinById?id=",
    GBGroupPinArchived: "GeneralSetup/GBGroupPinArchived",
    GetEthnicOriginListing: "GeneralSetup/GetEthnicOriginListing",
    EthnicOriginSave: "GeneralSetup/EthnicOriginSave",
    GetEthnicOriginById: "GeneralSetup/GetEthnicOriginById?id=",
    EthnicOriginArchived: "GeneralSetup/EthnicOriginArchived",
    GetDocumentLibraryListing: "GeneralSetup/GetDocumentLibrariesList",
    DocumentLibrarySave: "GeneralSetup/DocumentLibrarySave",
    GetDocumentLibraryById: "GeneralSetup/GetDocumentLibraryById?id=",
    DocumentLibraryArchived: "GeneralSetup/DocumentLibraryArchived",
    DocumentLibraryCopyUrl: "GeneralSetup/DocumentLibraryCopyUrl",
    GetDivisionListing: "GeneralSetup/GetDivisionListing",
    DivisionSave: "GeneralSetup/DivisionSave",
    GetDivisionById: "GeneralSetup/GetDivisionById?id=",
    DivisionArchived: "GeneralSetup/DivisionArchived",
    GetDepartmentListing: "GeneralSetup/GetDepartmentListing",
    DepartmentSave: "GeneralSetup/DepartmentSave",
    GetDepartmentById: "GeneralSetup/GetDepartmentById?id=",
    DepartmentArchived: "GeneralSetup/DepartmentArchived",
    GetCostCentreListing: "GeneralSetup/GetCostCentreListing",
    GetCostCentreListForDropDown: "GeneralSetup/GetCostCentreListingForDropDown",
    GetBoardPositionListingForDropDown: "GeneralSetup/GetBoardPositionListingForDropDown",
    CostCentreSave: "GeneralSetup/CostCentreSave",
    GetCostCentreById: "GeneralSetup/GetCostCentreById?id=",
    CostCentreArchived: "GeneralSetup/CostCentreArchived",
    GetCandidateApplicationStatusListing: "GeneralSetup/GetCandidateApplicationStatusListing",
    CandidateApplicationStatusSave: "GeneralSetup/CandidateApplicationStatusSave",
    CandidateApplicationStatusArchived: "GeneralSetup/CandidateApplicationStatusArchived",
    GetCampaignListing: "GeneralSetup/GetCampaignListing",
    CampaignSave: "GeneralSetup/CampaignSave",
    GetCampaignById: "GeneralSetup/GetCampaignById?id=",
    CampaignArchived: "GeneralSetup/CampaignArchived",
    GetAgencyListing: "GeneralSetup/GetAgencyListing",
    AgencySave: "GeneralSetup/AgencySave",
    AgencyUserSave: "GeneralSetup/AgencyUserSave",
    DeleteAgencyUser: "GeneralSetup/DeleteAgencyUser",


    GetAgencyById: "GeneralSetup/GetAgencyById?id=",
    GetAgencyAttachmentById: "GeneralSetup/GetAgencyAttachmentById?id=",
    AgencyArchived: "GeneralSetup/AgencyArchived",
    GetAdvertListing: "GeneralSetup/GetAdvertListing",
    AdvertSave: "GeneralSetup/AdvertSave",
    GetAdvertById: "GeneralSetup/GetAdvertById?id=",
    AdvertArchived: "GeneralSetup/AdvertArchived",
    GetAdvertCategoryListing: "GeneralSetup/GetAdvertCategoryListing",
    AdvertCategorySave: "GeneralSetup/AdvertCategorySave",
    GetAdvertCategoryById: "GeneralSetup/GetAdvertCategoryById?id=",
    AdvertCategoryArchived: "GeneralSetup/AdvertCategoryArchived",
    GetAllAdverts: "GeneralSetup/GetAllAdverts?controllerName=",

    GetAddressBookListing: "GeneralSetup/GetAddressBookListing",
    AddressBookSave: "GeneralSetup/AddressBookSave",
    GetAddressBookById: "GeneralSetup/GetAddressBookById?id=",
    AddressBookArchived: "GeneralSetup/AddressBookArchived",
    SkillCategorySave: "GeneralSetup/SkillCategorySave",
    GetSkillCategoryById: "GeneralSetup/GetSkillCategoryById?id=",
    SkillCategoryArchived: "GeneralSetup/SkillCategoryArchived",
    GetSkillCategoryListing: "GeneralSetup/GetSkillCategoryListing",
    SkillSave: "GeneralSetup/SkillSave",
    GetSkillById: "GeneralSetup/GetSkillById?id=",
    SkillArchived: "GeneralSetup/SkillArchived",
    GetSkillListing: "GeneralSetup/GetSkillListing",

    GetAccountCodesListing: "GeneralSetup/GetAccountCodesListing",
    GetAccountCodeById: "GeneralSetup/GetAccountCodeById?id=",
    CreateAccountCodesListing: "GeneralSetup/CreateAccountCodesListing",
    SaveParseAccounts: "GeneralSetup/SaveParseAccounts",
    AccountCodeDelete: "GeneralSetup/AccountCodeArchived",

    GetCostCodesListing: "GeneralSetup/GetCostCodesListing",
    GetCostCodesById: "GeneralSetup/GetCostCodeById?id=",
    CreateCostCodesListing: "GeneralSetup/CreateCostCodesListing",
    CostCodesDelete: "GeneralSetup/CostCodeArchived",

    GetBoardPositionListing: "GeneralSetup/GetBoardPositionListing",
    GetBoardPositionById: "GeneralSetup/GetBoardPositionById?id=",
    CreateBoardPositionListing: "GeneralSetup/CreateBoardPositionListing",
    BoardPositionDelete: "GeneralSetup/BoardPositionArchived",
    SaveParseBoard: "GeneralSetup/SaveParseBoard",
    SaveParseCost: "GeneralSetup/SaveParseCost",

  },
  //Calendar: {
  //  GetListing: "Calendar/GetListing",
  //  GetCalendarLookup: "Calendar/GetCalendarLookup",
  //  Save: "Calendar/Save",
  //  Update: "Calendar/Update",
  //  Upload: "Calendar/Upload",
  //  GetAllById: "Calendar/GetAllById?id=",
  //  GetById: "Calendar/GetById?id=",
  //  Archived: "Calendar/Archived",
  //  UnArchive: "Calendar/UnArchive",
  //  Copy: "Calendar/Copy",
  //  NameParams: "&controllerName=",
  //  GetDetailTabById: "Calendar/CalendarDetails?id=",
  //  GetUserId: "Calendar/GetUser",
  //  GetBookedCandidate: "Calendar/GetBookedCandidate?id=",
  //  GetAppointments: "Calendar/GetAppointments",
  //  Vacant: "Calendar/GetVacantSlots?id=",
  //  GetAppointmentsCount: "Calendar/GetAppointmentsCDCount"
  //},
  AlertSetup: {
    NameParams: "&controllerName=",
    Tiles: "Settings/GeneralSettings",
    GetAlertSetupListing: "AlertSetup/GetAlertSetupListing",
    GetCandidateAlertListing: "AlertSetup/GetCandidateAlertListing",
    SaveMyCandidateAlert: "AlertSetup/SaveMyCandidateAlert",
    GetCandidateAlertById: "AlertSetup/GetCandidateAlertById?id=",
    DeleteCandidateAlert: "AlertSetup/DeleteCandidateAlert",
    GetDataCandidateAlrets: "AlertSetup/GetDataCandidateAlrets",



    GetTextMessageListing: "AlertSetup/GetTextMessageListing",
    GetMyEmailListing: "AlertSetup/GetMyEmailListing",

    ArchivedSystemAlert: "AlertSetup/ArchivedSystemAlert",
    SaveSystemAlert: "AlertSetup/SaveSystemAlert",
    GetSystemAlertById: "AlertSetup/GetSystemAlertById?id=",
    GetSystemAlertModelById: "AlertSetup/GetSystemAlertDetailById?id=",
    SaveSystemAlertDetail: "AlertSetup/SaveSystemAlertDetail",
    ArchivedSystemAlertDetail: "AlertSetup/ArchivedSystemAlertDetail?id=",

    GetMyCandidateAlert: "AlertSetup/GetMyCandidateAlert",


  },
  EmailOptions: {
    GetListing: "Communication/GetEmailTemplates",
    Archive: "Communication/ArchiveEmailTemplates",
    CreateGet: "Communication/GetEmailTemplate/",
    CreateSave: "Communication/SaveEmailTemplate/",
    GetStandardEmails: "Communication/GetStandardEmails",
    CopyEmailTemplate: "Communication/CopyEmailTemplate",
  },
  EmailInbox: {
    GetEmailInboxList: "Communication/GetEmailInboxList",
    EmailInboxMarkAsRead: "Communication/EmailInboxMarkAsRead",
    EmailInboxMarkAsUnRead: "Communication/EmailInboxMarkAsUnRead",
    ArchiveEmailInbox: "Communication/ArchiveEmailInbox",
    GetEmailInbox: "Communication/GetEmailInbox/",
    ForwardEmailInbox: "Communication/ForwardEmailInbox",
    ReplyEmailInbox: "Communication/ReplyEmailInbox",
  },
  LetterOptions: {
    GetListing: "Communication/GetLetterTemplates",
    Archive: "Communication/ArchiveLetterTemplates",
    CreateGet: "Communication/GetLetterTemplate/",
    CreateSave: "Communication/SaveLetterTemplate/",
  },
  Contracts: {
    GetListing: "Communication/GetContractsList",
    Archive: "Communication/ArchiveContracts",
    CreateGet: "Communication/GetContract/",
    CreateSave: "Communication/SaveContract/",
  },
  ContractSection: {
    GetListing: "Communication/GetContractSectionsList",
    Archive: "Communication/ArchiveContractSections",
    CreateGet: "Communication/GetContractSection/",
    CreateSave: "Communication/SaveContractSection/",
    GetTextRepositoryList: "Communication/GetTextRepositoryList/",
    GetTextRepositories: "Communication/GetTextRepositories/",
  },
  EmailOutbox: {
    GetEmailOutboxList: "Communication/GetEmailOutboxList",
    GetEmailOutbox: "Communication/GetEmailOutbox/",
    ForwardEmailOutbox: "Communication/ForwardEmailOutbox",
  },
  //SmsOptions: {
  //  GetSmsTemplates: "Communication/GetSmsTemplates",
  //  GetSmsTemplate: "Communication/GetSmsTemplate/",
  //  SaveSmsTemplate: "Communication/SaveSmsTemplate",
  //  ArchiveSmsTemplate: "Communication/ArchiveSmsTemplate",
  //  GetStandardSms: "Communication/GetStandardSms"
  //},
  SmsOutbox: {
    GetSmsDetail: "Communication/GetSmsDetail",
    GetInboxSmsDetail: "Communication/GetInboxSmsDetail"
  },
  Search: {
    GetSearchJobsFilterData: "Search/GetSearchJobsFilterData",
    GetSearchCandidatesFilterData: "SearchHM/GetSearchCandidateFiltersData",
    GetAddressBook: "Search/GetAddressBook",
    GetAddressBook_Server: "SearchHM/GetAddressBook_Server",
    GetJobsSearchHMList: "SearchHM/GetJobsSearchHMList",
    GetCandidateSearchHMList: "SearchHM/GetCandidateSearchHMList",
    GetCandidateJobSearchHMList: "SearchHM/GetCandidateJobSearchHMList",
    GetLocation_Server: "SearchHM/GetLocation_Server",
    GetApplicationStatus_Server: "SearchHM/GetApplicationStatus_Server",
    GetTalentPool_Server: "SearchHM/GetTalentPool_Server",
    GetDocumentLibrary: "Search/GetDocumentLibrary",
    GetCandidateApplicationDocuments: "Search/GetCandidateApplicationDocuments",
  },

  GreenRoomTemplates: {
    GetGreenRoomTemplatesList: "GreenRoomSetUp/GetGreenRoomTemplatesList",
    Save: "GreenRoomSetUp/SaveGreenRoomTemplates",
    GetById: "GreenRoomSetUp/GetGreenRoomTemplatesById?id=",
    GetGreenRoomTemplates_Lookup: "GreenRoomSetUp/GetGreenRoomTemplates_Lookup",
    Archived: "GreenRoomSetUp/DeleteGreenRoomTemplates",
    NameParams: "&controllerName=",
    GetMediaLibrariesList: "GreenRoomSetUp/GetMediaLibraryList?type=",
    Copy: "GreenRoomSetUp/CopyGreenRoomTemplates",

  },

  KeyContacts: {
    GetKeyContactsList: "GreenRoomSetUp/GetKeyContactsList",
    Save: "GreenRoomSetUp/SaveKeyContacts",
    GetById: "GreenRoomSetUp/GetKeyContactsById?id=",
    Archived: "GreenRoomSetUp/DeleteKeyContacts",
    NameParams: "&controllerName=",
  },
  Links: {
    GetLinksList: "GreenRoomSetUp/GetLinksList",
    Save: "GreenRoomSetUp/SaveLinks",
    GetById: "GreenRoomSetUp/GetLinksById?id=",
    Archived: "GreenRoomSetUp/DeleteLinks",
    NameParams: "&controllerName=",
  },

  Managers: {
    GetManagersList: "GreenRoomSetUp/GetManagersList",
    Save: "GreenRoomSetUp/SaveManagers",
    GetById: "GreenRoomSetUp/GetManagersById?id=",
    Archived: "GreenRoomSetUp/DeleteManagers",
    NameParams: "&controllerName=",

  },

  OnBoardingSettings: {
    GetOnBoardigSettings: "OnBoarding/GetOnBoardingSettings",
    Save: "OnBoarding/SaveOnBoardigSettings",
    NameParams: "&controllerName=",
    DeleteCheckList: "OnBoarding/DeleteCheckList?id=",
    GetOnbhoardingStatuses: "OnBoarding/GetOnbhoardingSettingsStatuses",

  },

  DataListView: {
    SaveSearchRecords: "Search/SaveSearchRecords",
    GetTalentPools: "LookUp/GetTalentPools",
    AssignToTalentPool: "Search/AssignToTalentPool",
    AssignToJob: "Search/AssignToJob",
    MoveToJob: "Search/MoveToJob",
    SendSms: "Search/SendSms",
    SendEmailToQueue: "Job/SendEmail",
    GetCandidateDetails: "Search/GetCandidateDetails?CandidateId=",
    ForwardDetailEmail: "Job/ForwardDetailEmail",
    SendToAgencey: "Job/SendToAgencey",
    SendToReference: "Job/SendToReference",
    GetReferees: "Job/GetReferees",
    GetAgencyById: "Job/GetAgencyById?AgencyId=",
    TagReplacement: "Job/TagReplacement",
    TagReplacements: "Job/TagReplacements",
    OnboardingSendToReference: "OnBoarding/SendToReference",
  },
  SystemSettings: {
    GetListing: "SystemSettings/GetListing",
    GetLocations: "SystemSettings/GetLocations",
    Save: "SystemSettings/Save",
    GetById: "SystemSettings/GetById?id=",
    Archived: "SystemSettings/Archived",
    NameParams: "&controllerName=",
    GetAuthorisationTemplateListing: "SystemSettings/GetAuthorisationTemplateListing",
    GetTeamListing: "SystemSettings/GetTeamListing",
    TeamSave: "SystemSettings/TeamSave",
    GetTeamById: "SystemSettings/GetTeamById?id=",
    TeamArchived: "SystemSettings/TeamArchived",
    GetAuthorisationTemplatesListing: "SystemSettings/GetAuthorisationTemplatesListing",
    AuthorisationTemplateSave: "SystemSettings/AuthorisationTemplateSave",
    GetAuthorisationTemplateById: "SystemSettings/GetAuthorisationTemplateById?id=",
    AuthorisationTemplateArchived: "SystemSettings/AuthorisationTemplateArchived",
    GetAuthorisationUserListing: "SystemSettings/GetAuthorisationUserListing",
    AuthorisationUserSave: "SystemSettings/AuthorisationUserSave",
    GetAuthorisationUserById: "SystemSettings/GetAuthorisationUserById?id=",
    AuthorisationUserArchived: "SystemSettings/AuthorisationUserArchived",
    GetUserDetails: "SystemSettings/GetUserDetails",
    SendContactEmail: "SystemSettings/SendContactEmail",
    GetSystemPipelineListing: "SystemSettings/GetSystemPipelineListing",
    SaveSystemPipeline: "SystemSettings/SaveSystemPipeline",
    GetSystemPipelineStatuses: "SystemSettings/GetSystemPipelineStatuses",
    EmailSecurityCode: "SystemSettings/EmailSecurityCode",
    VerifySecurityCode: "SystemSettings/VerifySecurityCode",
    ChangePassword: "SystemSettings/ChangePassword",
    UpdateSystemUserPassword: "SystemSettings/UpdateUserPassword",

  },
  MultiDocument: {
    Tiles: "Settings/GeneralSettings",
    GetListing: "MultiDocument/GetListing",
    Save: "MultiDocument/Save",
    GetById: "MultiDocument/GetById?id=",
    Archived: "MultiDocument/Archived",
    NameParams: "&controllerName=",
    GetDocumentPreview: "MultiDocument/GetDocumentPreview",
    SaveMultiDocuments: "MultiDocument/SaveMultiDocuments",
    GetMultiDocumentById: "MultiDocument/GetMultiDocumentById?id=",
    MultiDocumentArchived: "MultiDocument/MultiDocumentArchived",
    GetMultiDocumentListing: "MultiDocument/GetMultiDocumentListing",
  },
  //Candidate: {


  //  RemoveAlertNotes: "Candidate/RemoveAlertNotes",
  //  GetAssessmentFormQuestions: "Candidate/GetAssessmentFormQuestions?AssessmentFormId=",
  //  ListNoteAlerts: "Candidate/ListNoteAlerts",
  //  GetTemplateDetails: "Candidate/GetTemplateDetails",
  //  GetSavedDetails: "Candidate/GetSavedDetails",
  //  DeleteSavedDetails: "Candidate/DeleteSavedDetails",
  //  GetCVPreviewDetails: "Candidate/GetCVPreviewDetails",
  //  GetCVDetails: "Candidate/GetCVDetails",
  //  GetMultiDocsDetails: "Candidate/GetMultiDocsDetails",
  //  SaveTemplateData: "Candidate/SaveTemplateData",
  //  SaveCandidateImages: "Candidate/SaveCandidateImages",
  //  GetCandidateImages: "Candidate/GetCandidateImages",
  //  GetDeclarationDetails: "Candidate/GetDeclarationDetails",
  //  SaveCVAndCoverLetter: "Candidate/SaveCVAndCoverLetter",
  //  SaveMultiDocs: "Candidate/SaveMultiDocs",
  //  GetAssessmentDetails: "Candidate/GetAssessmentDetails",
  //  GetAssessmentBDetails: "Candidate/GetAssessmentBDetails",
  //  GetPreAssessmentDetails: "Candidate/GetPreAssessmentDetails",
  //  SelectAssessmentForm: "Candidate/SelectAssessmentForm",
  //  SaveAssessmentFormAnswers: "Candidate/SaveAssessmentFormAnswers",
  //  PrintApplication: "Candidate/PrintApplication",
  //  GetLeftMenuData: "Candidate/GetLeftMenuData",
  //  GetCandidateDetailSecurityRoles: "Candidate/GetCandidateDetailSecurityRoles",
  //  GetSecurityRoleDetails: "Candidate/GetSecurityRoleDetails",
  //  GetPrintLetterData: "Candidate/GetPrintLetterData",
  //  PrintLetter: "Candidate/PrintLetter",
  //  GetPrintContractData: "Candidate/GetPrintContractData",
  //  PrintContract: "Candidate/PrintContract",
  //  CompareCandidates: "Candidate/CompareCandidates",
  //  GetOfferAuthorizationStep1: "Candidate/GetOfferAuthorizationStep1",
  //  SaveOfferAuthorizationStep1: "Candidate/SaveOfferAuthorizationStep1",
  //  GetOfferAuthorizationStep2: "Candidate/GetOfferAuthorizationStep2",
  //  StartTimedForm: "Candidate/StartTimedForm",
  //  UpdateApplicationTimedCandidateFromGroupTime: "Candidate/UpdateApplicationTimedCandidateFromGroupTime",
  //  UpdateApplicationTimedCandidateFromGroup: "Candidate/UpdateApplicationTimedCandidateFromGroup",
  //  GetSpecialAdjustmentDetails: "Candidate/GetSpecialAdjustmentDetails",
  //  SaveSpecialAdjustmentDetails: "Candidate/SaveSpecialAdjustmentDetails",
  //  GetResetTestDetails: "Candidate/GetResetTestDetails",
  //  ResetTest: "Candidate/ResetTest",
  //  SaveDeclaration: "Candidate/SaveDeclaration",
  //  CandidateApplicationInterview: "Candidate/CandidateApplicationInterview",
  //  CandidateApplicationInterviewDelete: "Candidate/CandidateApplicationInterviewDelete",
  //  CandidateDetail: "Candidate/CandidateDetail?candidateId=",
  //  CandidateInterviewDetail: "Candidate/CandidateInterviewDetail?candidateId=",
  //  ListAppointments: "Candidate/ListAppointments?candidateId=",
  //  ListSlots: "Candidate/ListSlots?candidateId=",
  //  AppointmentConfirm: "Candidate/AppointmentConfirm?candidateId=",
  //  BookAppointment: "Candidate/BookAppointment",
  //  CancelAppointment: "Candidate/CancelAppointment?candidateId=",
  //  GetCandidateJobId: "Candidate/GetCandidateJobId?id=",
  //  NameParams: "&jobId=",
  //  SaveTattoImage: "Candidate/SaveTattoImage",
  //  GetCandidate: "Candidate/GetCandidate",
  //  CandidateRegister: "Candidate/CandidateRegister"

  //},
  //Talents: {
  //  GetListing: "HMTalent/GetTalentListing",
  //  GetPoolCandidateListing: "HMTalent/GetPoolCandidateListing?TalentPoolId=",
  //  SaveTalenPoolCandidateRanking: "HMTalent/SaveTalenPoolCandidateRanking",
  //  GetNotification: "HMTalent/GetNotification"


  //},

  GradeFare: {
    GetListOfTalent: "GradeFare/GetListOfTalent",
    TalentCandidateDetail: "GradeFare/TalentCandidateDetail",
    AddTalentCandidateNote: "GradeFare/AddTalentCandidateNote",
    GetTalentCandidateNote: "GradeFare/GetTalentCandidateNote",
    RemovCandidatesFromTalentCommunity: "GradeFare/RemovCandidatesFromTalentCommunity",
    TagReplacement: "GradeFare/TagReplacement",
    GetSendEmailData: "GradeFare/GetSendEmailData",
    SendEmail: "GradeFare/SendEmail",
    AssignToJob: "GradeFare/AssignToJob",
    GetTalentCandidateDetail: "GradeFare/GetTalentCandidateDetail",
    SaveCandidate: "GradeFare/SaveCandidate",
    GetCandidate: "GradeFare/GetCandidate?id=",
    GetSentEmails: "GradeFare/GetSentEmails",
    GetHistory: "GradeFare/GetHistory",
    GetHeaderFoter: "GradeFare/GetHeaderFooter",
    GetCV: "GradeFare/GetCV",
    SearchUniversity: "GradeFare/SearchUniversity",
    GetCommunityName: "GradeFare/GetCommunityName?id=",
  },
  WorkPlace: {
    GetMyNewApplicationListing: "Talent/GetMyNewApplicationListing",
    GetCandidateShortlisting: "Talent/GetCandidateShortlisting",
    MyJobs: "Job/GetMyJobs",
    AddtoMyJobs: "Job/AddtoMyJobs",
    RemoveMyJobs: "Job/RemoveMyJobs",
    ApproveDeclineRequisition: "Job/ApproveDeclineRequisition",


    UsersUpload: "Job/UsersUpload",
    LeaversUpload: "Job/LeaversUpload"
  },
  VideoInterviewIntegration: {
    LaunchPadPlayBackApi: "Integration/LaunchPadPlayBackApi",
    GetInterviews: "Integration/GetInterviews",
    InviteToInterview: "Integration/CreateCandidate",
    GetInterviewDetails: "Integration/GetInterviewDetails",
    InviteCandidateToRetakeInterview: "Integration/InviteCandidateToRetakeInterview"
  },
  Integration: {
    GetShlScore: "Integration/GetShlScore",
    ResetTest: "Integration/ResetTest",
    GetInterviews: "Integration/GetInterviews",
    GetCentralTestAssessmentReport: "Integration/GetCentralTestAssessmentReport",
    GetCandidateReportLinkCute: "Integration/GetCandidateReportLink_Cute",
    GetCandidateReportLink_Cute_EnhancedProject: "Integration/GetCandidateReportLink_Cute_EnhancedProject",
    GetScoresObj_Cute_EnhancedProject: "Integration/GetScoresObj_Cute_EnhancedProject",
    GetScoresObj_Cute: "Integration/GetScoresObj_Cute"
  },
  LaunchPadIntegration: {
    GetInterviewStatus: "Integration/GetLaunchPadInterviewStatus",
    GetInterviews: "Integration/GetLaunchPadInterviews",
    InviteToInterview: "Integration/LaunchPadCreateCandidate"
  },
  OnlineDisclosureIntegration: {
    GetOnlineDisclosureInfo: "Integration/GetOnlineDisclosureInfo",
    RegisterApplicant: "Integration/RegisterApplicant"
  },
  JobsandTalent: {
    GetTabsData: "Job/GetTabsData",
    ListOfCandidates: "Job/ListOfCandidates",
    GetJobTitleRef: "Job/GetJobTitleRef",
    GetApplicationFormTabData: "Job/GetApplicationFormTabData",
    UpdateCandidateStatus: "Candidate/UpdateCandidateStatus",
    BulkUpdateCandidateStatus: "Candidate/BulkUpdateCandidateStatus",

    GetCandidateCVDetail: "Candidate/GetCandidateCVDetail",
    UploadCandidateCV: "Candidate/UploadCandidateCV",

    GetJobDetails: "Job/GetJobDetails",
    GetJobListing: "Job/GetJobListing",
    GetJobListingInfo: "Job/GetJobListingInfo",
    GetJobDetail: "Job/GetJobDetail",
    GetJobAdverts: "Job/GetJobAdverts",
    GetSmartSearch: "Job/GetSmartSearch",
    GetApprovalForm: "Job/GetApprovalForm",
    ResendRequisition: "Job/ResendRequisition",
    ApproveRequisition: "Job/ApproveRequisition",
    GetCandidateList: "Job/GetCandidateListByJob",

    SaveJobDetails: "Job/SaveJobDetails/",
    GetCompareShortListing: "Candidate/GetCompareShortListing",
    OfferAuthorizationActions: "Candidate/OfferAuthorizationActions",
    RefreshStatus: "CandidateDetail/RefreshStatus",
    MyOfferAuthorizationActions: "Candidate/MyOfferAuthorizationActions",
    GetDiversityCount: "Home/GetDiversityCount",
    SaveJobAdverts: "Job/SaveJobAdverts/",
    SaveAssesment: "Job/SaveAssesment/",
    SaveApprovalForm: "Job/SaveApprovalForm",
    SaveJobNote: "Job/SaveJobNote",
    CheckCandidatePackSecurity: "Candidate/CheckCandidatePackSecurity",
    CheckCandidatePackDocSecurity: "Candidate/CheckCandidatePackDocSecurity",
    GetBookedCandidates: "Job/GetBookedCandidate?id=",
    GetSystemPipelines: "Job/GetSystemPipelines?id=",
    CandidateStatusUpdate: "Job/UpdateCandidateStatus/",
    GetCandidateReligionDetail: "Candidate/GetCandidateReligionDetail",

  },
  FDMAllocation: {
    GetAllocatedCandidate: "Allocation/GetAllocatedCandidate",
    GetUnAllocatedCandidate: "Allocation/GetUnAllocatedCandidate",
    GetNewCandidate: "Allocation/GetNewCandidate",
    GetReminderCandidate: "Allocation/GetReminderCandidate",
    GetDeferredCandidates: "Allocation/GetDeferredCandidates",
    UndeferCandidates: "Allocation/UndeferCandidates",
    GetCandidateDetails: "Allocation/GetCandidateDetails?id=",
    AddCandidateNote: "Allocation/AddCandidateNote",
    GetCandidateNotes: "Allocation/GetCandidateNotes",
    GetDeferredtDetails: "Allocation/GetDeferredtDetails?id=",
    AddRemoveDeferred: "Allocation/AddRemoveDeferred",
    UpdateAllocationSetting: "Allocation/UpdateAllocationSetting",
    UnAllocateCandidate: "Allocation/UnAllocateCandidate",
    RemoveCandidateFromRecuiter: "Allocation/RemoveCandidateFromRecuiter",
    //ReAssignRecruiter: "Allocation/ReAssignRecruiter",
    GetCandidateDetailsbyApplicationId: "Allocation/GetCandidateDetailsbyApplicationId",
    AssignToRecruiter: "Allocation/AssignToRecruiter",
    AllocationSetting: "Allocation/GetAllocationSetting",
    GetUserDetails: "Allocation/GetUserDetails?id=",
    GetCandidate: "Allocation/GetCandidate",
    CandidateRegister: "Allocation/CandidateRegister",
    GetActionRules: "Allocation/GetActionRules?id=",
    GetManuallAllocationDetailByCandidate: "Allocation/GetManuallAllocationDetailByCandidate",
    DoManuallAllocationByCandidate: "Allocation/DoManuallAllocationByCandidate",
    GetPrintLetterData: "GradeFare/GetPrintLetterData",
    PrintLetter: "GradeFare/PrintLetter",



  },
  HomePage: {
    GetApplicationHiredCount: "Home/GetApplicationHiredCount",
    GetBottleNeck: "Home/GetBottleNeck",
    GetListHomeCandidates: "Home/GetHomeListOfCandidatesByDate",
    GetHomeCandidates: "Home/GetListOfCandidates",
    GetHomeCandidatesByDate: "Home/GetListOfCandidatesByDate",
    GetHomeClosingJobs: "Home/GetListClosingJobs",
    GetAdvert: "Home/GetAdvertReport",
    GetApplicationPerDay: "Home/GetApplicationPerDay",
    GetHomeListOfShortlistingCandidates: "Home/GetListOfShortlistingCandidates",
    GetCandidateCount: "Home/GetCandidateCount",
    GetHomeInterviews: "Home/GetListOfInterViewsForDashboard",
    SaveHomeNote: "Home/SaveHomeNote",
    DeleteHomeNote: "Home/DeleteHomeNote?id=",
    GetHomeNotes: "Home/GetHomeNotes",
    RestoreDeletedNote: "Home/RestoreDeletedNote?id=",
    GetHomeListOfOfferMadeJobCandidates: "Home/GetListOfOfferMadeJobCandidates",
    GetTimeToApprove: "Home/GetTimeToApprove",
    GetTilesConfigration: "Home/GetTilesConfigration",
    GetQuickLinks: "Home/GetQuickLinks",

  },
  ParseUpload: {
    SaveParseCandidate: "ParseUpload/SaveParseCandidate",
    RecentlyUploadedCandidates: "ParseUpload/GetRecentUploadListing",
    RecentlyUploadedCandidatesDetails: "ParseUpload/GetRecentlyUploadedCandidateDetails",
    CandidateQualifications: "ParseUpload/GetCandidateQualifications",
    CandidateTrainingCourse: "ParseUpload/GetCandidateTrainingCourse",
    CandidatesReferences: "ParseUpload/GetCandidateReferences",
    CandidatesEmployers: "ParseUpload/GetCandidateEmployers",
    CandidatesEqualOpps: "ParseUpload/GetCandidateEqualOpps",
    RemoveCandidate: "ParseUpload/RemoveCandidate",
    CandidateImport: "ParseUpload/CandidateImportToJob",
    NHSCandidateImport: "ParseUpload/NHSCandidateImport",
  },
  CandidateDetail: {
    GetLeftMenuChecks: "CandidateDetail/GetLeftMenuChecks",
    GetCandidateListInformation: "CandidateDetail/GetCandidateListInformation",
    GetCandidateDetail: "CandidateDetail/GetCandidateDetail",
    GetOnboardingStatusId: "CandidateDetail/GetOnboardingStatusId",
    GetTabsDetail: "CandidateDetail/GetTabsDetail",
    GetMultiUploadsDetails: "CandidateDetail/GetMultiUploadsDetails",
    UploadDocument: "CandidateDetail/UploadDocument",
    DocumentPreview: "CandidateDetail/DocumentPreview",
    DeleteDocument: "CandidateDetail/DeleteDocument",
    GetDocument: "CandidateDetail/GetDocument",
    GetNoteDetail: "CandidateDetail/GetNoteDetail",
    SaveNote: "CandidateDetail/SaveNote",
    GetNotes: "CandidateDetail/GetNotes",
    SetInternalExternal: "CandidateDetail/SetInternalExternal",
    DeleteApplication: "CandidateDetail/DeleteApplication",
    EmailNewPassword: "CandidateDetail/EmailNewPassword",
    EmailSecurityCode: "CandidateDetail/EmailSecurityCode",
    VarifySecurityCode: "CandidateDetail/VarifySecurityCode",
    ChangePassword: "CandidateDetail/ChangePassword",
    GetOpportunityAlerts: "CandidateDetail/GetOpportunityAlerts",
    CandidateRegisterDetail: "CandidateDetail/CandidateRegisterDetail",
    UnlockCandidateAccount: "CandidateDetail/UnlockCandidateAccount",
    RemoveAlertNotes: "CandidateDetail/RemoveAlertNotes",
    UpdateCandidateRanking: "CandidateDetail/UpdateCandidateRanking",
    GetApplicationStatusesAndStatusChangeReasons: "CandidateDetail/GetApplicationStatusesAndStatusChangeReasons",
    GetCandidateTemplateId: "CandidateDetail/GetCandidateTemplateId",
    GetHistoryCommints: "CandidateDetail/GetHistoryCommints",
    GetCandidateHistory: "CandidateDetail/GetCandidateHistory",
    GetScore: "CandidateDetail/GetScore",
    ShortListComplete: "CandidateDetail/ShortListComplete",
  },

  Templates: {
    GetTemplatesList: "OnBoarding/GetTemplatesList",
    SaveTemplates: "OnBoarding/SaveTemplates",
    SaveTemplatesDocuments: "OnBoarding/SaveTemplatesDocuments",
    GetTemplatesById: "OnBoarding/GetTemplatesById",
    GetTemplates: "OnBoarding/GetSystemTemplates",
    GetDocumentById: "OnBoarding/GetDocumentLibraryById?id=",
    Archived: "OnBoarding/ArchiveTemplates",
    NameParams: "&controllerName=",
  },

  OnBoardingForm: {
    GetOnBoardingFormList: "OnBoarding/GetOnBoardingFormList",
    SaveOnBoardingForm: "OnBoarding/SaveOnBoardingForm",
    GetOnBoardingFormById: "OnBoarding/GetOnBoardingFormById?id=",
    GetAssessmentFormQuestions: "OnBoarding/GetAssessmentFormQuestions?AssessmentFormId=",
    Archived: "OnBoarding/ArchiveForm",
    UpdateOnBoardingFormQuestion: "OnBoarding/UpdateOnBoardingFormQuestion",
    GetAssessmentFormQuestion: "OnBoarding/GetAssessmentFormQuestion",
    AddAssessmentFormQuestion: "OnBoarding/AddAssessmentFormQuestion",
    GetAssessmentFormById: "OnBoarding/GetAssessmentFormById?AssessmentFormId=",
    CopyAssessmentForms: "OnBoarding/CopyAssessmentForms",
    ReOrderOnBoardingForm: "OnBoarding/ReorderOnBoardingForm?ApplicationFormId=",
    PreviewOnBoardingForm: "OnBoarding/GetPreviewOnBoardingForm?ApplicationFormId=",
    DeleteQuestions: "OnBoarding/DeleteQuestions",
    CheckQuestionNo: "OnBoarding/CheckQuestionNo",


    NameParams: "&controllerName=",
  },
  SystemUser: {
    SendPasswordRemainder: "SystemUser/SendPasswordRemainder?SystemUserId=",
    SendSecurityCode: "SystemUser/SendSecurityCode",
    EmailSecurityCode: "SystemUser/EmailSecurityCode?SystemUserId=",
    UpdateUserPassword: "SystemUser/UpdateUserPassword",
    InitializeUpdatePassword: "SystemUser/InitializeUpdatePassword",
    DeleteSystemUsers: "SystemUser/DeleteSystemUsers",
    UnArchiveSystemUser: "SystemUser/UnArchiveSystemUser",
    ActivateSystemUser: "SystemUser/ActivateSystemUser",
    DeActivateSystemUser: "SystemUser/DeActivateSystemUser",
    CopySystemUsers: "SystemUser/CopySystemUsers",
    GetApplicationStatus: "SystemUser/GetApplicationStatus",
    SaveUser: "SystemUser/SaveUser",
    UpdateSystemUser: "SystemUser/UpdateSystemUser",
    GetSystemUserById: "SystemUser/GetSystemUserById?SystemUserId=",
    GetUserLogs: "SystemUser/GetUserLogs",
    GetUserListing: "SystemUser/GetUserListing",
    GetUserListingArchived: "SystemUser/GetUserListingArchived",
    GetJobs: "SystemUser/GetJobs",
    GetSystemUserData: "SystemUser/GetSystemUserData",
    GetSystemUserAdditionalDetail: "SystemUser/GetSystemUserAdditionalDetail",
    GetUserWelcomeListing: "SystemUser/GetUserWelcomeListing",
    SendWelcomeEmail: "SystemUser/SendWelcomeEmail",
    RevokeAllToken: "SystemUser/RevokeAllToken",
    RevokePreviousTokensAndKeepLast: "SystemUser/RevokePreviousTokensAndKeepLast",
    RevokeToken: "SystemUser/RevokeToken",
  },

  Talents: {
    GetListing: "HMTalent/GetTalentListing",
    GetPoolCandidateListing: "HMTalent/GetPoolCandidateListing",
    SaveTalenPoolCandidateRanking: "HMTalent/SaveTalenPoolCandidateRanking",
    GetNotification: "HMTalent/GetNotification"
  },
  AddressBook: {
    HMGetAddressbookListing: "HMAddressBook/HMGetAddressbookListing",
  },

  Dashboard: {
    HMGetDashboardListing: "HMDashboard/HMGetDashboardListing",
    GetJobListing: "HMDashboard/GetJobListing",
    GetLocations: "SystemSettings/GetLocations_LookUp",
    GetSystemJobStatuses: "SystemSettings/GetSystemJobStatuses",


  },
  NewStarter: {
    GetMyStarterListing: "OnBoarding/HMGetMyStarterListing",
  },

  Calendar: {
    GetAppointments: "HMCalendar/GetAppointments",
    GetAppointmentByDay: "HMCalendar/GetAppointmentByDay"
  },

  Candidate: {
    CandidateApplicationInterview: "Candidate/CandidateApplicationInterview",
    CandidateDetail: "Candidate/CandidateDetail?candidateId=",
    CandidateApplicationInterviewDelete: "Candidate/CandidateApplicationInterviewDelete",
    NameParams: "&jobId=",
    GetCandidateProfileLookUp: "HMCandidate/GetApplicationStatusesAndStatusChangeReasons",
    GetSettings: "SystemSettings/GetSystemSettings",
    Save: "HMCandidate/UpdateCandaiateStatus",
    GetAssessmentDetails: "Candidate/GetAssessmentDetails",
    GetAssessmentBDetails: "Candidate/GetAssessmentBDetails",
    GetPreAssessmentDetails: "Candidate/GetPreAssessmentDetails",
  },
  Lookup: {
    GetEmails: "LookUp/GetStandarEmails",
    GetSystemUser_Lookup: "LookUp/GetSystemUser_Lookup",
    GetJobs_LookUp: "LookUp/GetJobs_Server",
    GetSystemJobStatuses: "LookUp/GetSystemJobStatuses"
  },
  //AddJob: {
  //  GetJobDetails: "HMAddJob/GetJobDetails",
  //  GetDivisionsByDepartments: "HMAddJob/GetDivisionsByDepartments",
  //  GetSchoolLocationsByDepartments: "HMAddJob/GetSchoolLocationsByDepartments",
  //  GetCostCentresByDivisions: "HMAddJob/GetCostCentresByDivisions",
  //  GetCampaignByDivisions: "HMAddJob/GetCampaignByDivisions",
  //  GetDivisionsBySchoolLocations: "HMAddJob/GetDivisionsBySchoolLocations",
  //},

  AddJob: {
    GetJobDetails: "AddJob/GetJobDetails",
    SaveJobDetails: "AddJob/SaveJobDetails/",
    GetJobAdverts: "AddJob/GetJobAdverts",
    GetSmartSearch: "AddJob/GetSmartSearch",
    ResendRequisition: "AddJob/ResendRequisition",
    ApproveRequisition: "AddJob/ApproveRequisition",
    SaveJobAdverts: "AddJob/SaveJobAdverts/",
    SaveAssesment: "AddJob/SaveAssesment/",
    GetApprovalForm: "AddJob/GetApprovalForm",
    SaveJobDocumentApprovalForm: "AddJob/SaveJobDocumentApprovalForm",
    SaveApprovalForm: "AddJob/SaveApprovalForm",
    PostJob: "AddJob/PostJob",
    GetPostJobById: "AddJob/GetPostJobById?id=",
    GetJobAccessById: "AddJob/GetJobAccessById?id=",
    SaveJobAccess: "AddJob/SaveJobAccess",
    GetJobDetailsForBroadBean: "AddJob/GetJobDetailsForBroadBean?id=",
    PostJobToBroadBean: "AddJob/PostJobToBB",
    GetJobDetailsForJobBoards: "AddJob/GetJobDetailsForJobBoards?id=",
    PostJobToJobBoards: "AddJob/PostJobToJB",
    GetJobDetailsForCaterer: "AddJob/GetJobDetailsForCaterer?id=",
    PostJobToCaterer: "AddJob/PostJobToCaterer",
    GetJobDetailsForMonster: "AddJob/GetJobDetailsForMonster?id=",
    PostJobToMonster: "AddJob/PostJobToMonster",
    GetMonsterCountryList: "AddJob/GetMonsterCountryList",
    GetJobDetailsForReed: "AddJob/GetJobDetailsForReed?id=",
    PostJobToReed: "AddJob/PostJobToReed",
    GetJobSectors: "AddJob/GetJobSectors?id=",
    GetMonsterRegion: "AddJob/GetMonsterRegion?id=",
    GetMonsterCounty: "AddJob/GetMonsterCounty",
    AddExpenses: "AddJob/AddExpenses",
    GetJobExpense: "AddJob/GetJobExpense?id=",
    Copy: "AddJob/Copy",
    GetAssessmentScore: "AddJob/GetAssessmentScore?prams=",
    SaveAssessmentScore: "AddJob/SaveAssessmentScore",
    DeleteJobDocument: "AddJob/DeleteJobDocument",
    SaveJobDocument: "AddJob/SaveJobDocument",
    GetJobAssessment: "AddJob/GetJobAssessment",
    GetDivisionsByDepartments: "AddJob/GetDivisionsByDepartments/",
    GetDivisionsBySchoolLocations: "AddJob/GetDivisionsBySchoolLocations/",
    GetSchoolLocationsByDepartments: "AddJob/GetSchoolLocationsByDepartments/",
    GetCostCentresByDivisions: "AddJob/GetCostCentresByDivisions/",
    GetCampaignByDivisions: "AddJob/GetCampaignByDivisions",

    ServerSideLookUp: {
      GetJobLookUp: "AddJob/GetLookUpData"
    }
  },
  //CandidateDetail: {
  //  GetLeftMenuChecks: "CandidateDetail/GetLeftMenuChecks",
  //  GetCandidateListInformation: "CandidateDetail/GetCandidateListInformation",
  //  GetCandidateDetail: "CandidateDetail/GetCandidateDetail",
  //  GetOnboardingStatusId: "CandidateDetail/GetOnboardingStatusId",
  //  GetTabsDetail: "CandidateDetail/GetTabsDetail",
  //  GetMultiUploadsDetails: "CandidateDetail/GetMultiUploadsDetails",
  //  UploadDocument: "CandidateDetail/UploadDocument",
  //  DocumentPreview: "CandidateDetail/DocumentPreview",
  //  DeleteDocument: "CandidateDetail/DeleteDocument",
  //  GetDocument: "CandidateDetail/GetDocument",
  //  GetNoteDetail: "CandidateDetail/GetNoteDetail",
  //  SaveNote: "CandidateDetail/SaveNote",
  //  GetNotes: "CandidateDetail/GetNotes",
  //  SetInternalExternal: "CandidateDetail/SetInternalExternal",
  //  DeleteApplication: "CandidateDetail/DeleteApplication",
  //  EmailNewPassword: "CandidateDetail/EmailNewPassword",
  //  EmailSecurityCode: "CandidateDetail/EmailSecurityCode",
  //  VarifySecurityCode: "CandidateDetail/VarifySecurityCode",
  //  ChangePassword: "CandidateDetail/ChangePassword",
  //  GetOpportunityAlerts: "CandidateDetail/GetOpportunityAlerts",
  //  CandidateRegisterDetail: "CandidateDetail/CandidateRegisterDetail",
  //  UnlockCandidateAccount: "CandidateDetail/UnlockCandidateAccount",
  //  RemoveAlertNotes: "CandidateDetail/RemoveAlertNotes",
  //  UpdateCandidateRanking: "CandidateDetail/UpdateCandidateRanking",
  //  GetApplicationStatusesAndStatusChangeReasons: "CandidateDetail/GetApplicationStatusesAndStatusChangeReasons",
  //  GetCandidateTemplateId: "CandidateDetail/GetCandidateTemplateId",
  //  GetHistoryCommints: "CandidateDetail/GetHistoryCommints",
  //  GetCandidateHistory: "CandidateDetail/GetCandidateHistory",
  //  GetScore: "CandidateDetail/GetScore",
  //  ShortListComplete: "CandidateDetail/ShortListComplete",
  //},
  SmsOptions: {
    GetStandardSms: "Communication/GetStandardSms",
   // SendSms: "Search/SendSms",
    SendSms: "CandidateDetail/SendSms",
  },
}

